import { render, staticRenderFns } from "./MUITQA.vue?vue&type=template&id=08d4ca9a&scoped=true"
import script from "./MUITQA.vue?vue&type=script&lang=js"
export * from "./MUITQA.vue?vue&type=script&lang=js"
import style0 from "./MUITQA.vue?vue&type=style&index=0&id=08d4ca9a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d4ca9a",
  null
  
)

export default component.exports